import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-progress-overlay__message" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-progress-overlay', $options.classes]),
    "data-qa": "progress-overlay"
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString($props.message), 1 /* TEXT */)
  ], 2 /* CLASS */))
}